// src/App.js

import React, { useEffect } from 'react';
// <<< MUDANÇA 1: Adicione o Outlet na importação do react-router-dom
import { BrowserRouter as Router, Routes, Route, Outlet } from 'react-router-dom';

import { AuthProvider } from './context/AuthContext'; 

import DashboardLayout from './components/DashboardLayout';
import DashboardPage from './pages/DashboardPage';
import CanvasDashboard from './pages/CanvasDashboard';
import CanvasEditor from './pages/CanvasEditor';
import RiskMapDashboard from './pages/RiskMapDashboard';
import RiskMapEditor from './pages/RiskMapEditor';

// <<< NOVO: Importação da página pública (vamos criar essa página no próximo passo)
import PublicCanvasEditor from './pages/PublicCanvasEditor';

function App() {
  // <<< MUDANÇA 2: Variável mágica que detecta se a tela está dentro de um Iframe (Memberkit)
  const isEmbedded = window.self !== window.top;

  useEffect(() => {
    // Esta lógica para pegar o token da URL já está perfeita para o SSO do Memberkit!
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    if (token) {
      localStorage.setItem('arp_token', token);
      window.history.replaceState(null, '', window.location.pathname);
    }
  }, []);

  return (
    <Router>
      <AuthProvider>
        <Routes>
          {/* <<< NOVO: ROTA PÚBLICA STANDALONE 
            Esta rota fica isolada, sem exibir a barra lateral e os menus do painel administrativo.
          */}
          <Route path="/shared/canvas/:shareToken" element={<PublicCanvasEditor />} />

          {/* <<< MUDANÇA 3: A lógica de injeção condicional do Layout */}
          {/* Se isEmbedded for true, usa o <Outlet /> (cru). Se não, usa o <DashboardLayout /> */}
          <Route element={isEmbedded ? <Outlet /> : <DashboardLayout />}>
            <Route path="/" element={<DashboardPage />} />
            <Route path="/canvases" element={<CanvasDashboard />} />
            <Route path="/canvas/:id" element={<CanvasEditor />} />
            
            <Route path="/riskmap" element={<RiskMapDashboard />} />
            <Route path="/riskmap/:id" element={<RiskMapEditor />} />
          </Route>
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;